<fd-dialog
  fdCompact
  [ngClass]="{
    dialogClass: dialogClass,
    'fullscreen-dialog': isExpanded,
  }"
>
  <fd-dialog-header fdCompact>
    <ng-template fdkTemplate="header">
      <div fd-bar-left>
        <fd-bar-element>
          <h1 fd-title class="dialog-header">
            @if (headerIcon) {
              <img
                src="{{ headerIcon }}"
                style="margin-left: -4px; margin-right: 4px"
              />
            }
            @if (headerGlyph) {
              <app-icon
                class="dialog-header-icon"
                [icon]="headerGlyph"
                size="lg"
              ></app-icon>
            }
            <span class="dialog-header-text">{{ headerText }}</span>
          </h1>
        </fd-bar-element>
      </div>
      <div fd-bar-right>
        @if (!!additionalHeaderButtons) {
          <ng-container
            *ngTemplateOutlet="additionalHeaderButtons"
          ></ng-container>
        }

        @if (showTopCancelButton) {
          <button
            tabindex="-1"
            fd-dialog-close-button
            class="cancel-btn"
            title="Close"
            [disabled]="busy"
            (click)="dialogRef.dismiss('Cancel')"
          ></button>
        }
      </div>
    </ng-template>
  </fd-dialog-header>

  <fd-dialog-body class="dialog-body">
    @if (contentVisible) {
      <div class="column-container">
        <div class="body-container">
          <ng-container *ngTemplateOutlet="body"></ng-container>
        </div>
        <div class="strip-container" #strip tabindex="-1">
          @if (!!errorMsg) {
            <app-error-strip
              [errorText]="errorText"
              [additionalContent]="additionalErrorContent"
              [errorMsg]="errorMsg"
            ></app-error-strip>
          }
        </div>
      </div>
    }
  </fd-dialog-body>

  @if (showFooter) {
    <fd-dialog-footer>
      @if (showCancelButton) {
        <fd-button-bar
          i18n-label="
            XBUT|Cancel button for the Session Expiry
            Dialog@@sessionExpiry.cancelButton"
          [label]="cancelText"
          fdType="transparent"
          [disabled]="busy"
          [fdCompact]="true"
          (click)="onCancel()"
          class="dialog-cancel-button uppercase-btn"
          id="dialog-cancel-btn"
          ariaLabel="Cancel"
        >
        </fd-button-bar>
      }
      @if (showSaveButton) {
        <fd-button-bar
          [label]="saveText"
          [fdType]="saveButtonType"
          [disabled]="!validationFn() || busy"
          [fdCompact]="true"
          (click)="this.save.emit($event)"
          id="dialog-submit-btn"
          class="dialog-save-button uppercase-btn"
          ariaLabel="OK Transparent"
        >
        </fd-button-bar>
      }
      @if (!!additionalFooterButtons) {
        <ng-container
          *ngTemplateOutlet="additionalFooterButtons"
        ></ng-container>
      }
    </fd-dialog-footer>
  }
</fd-dialog>
